const callbackSwedish = {
  processing: "Behandlar LinkedIn-auktorisering...",
  verifying: "Verifierar användarinformation...",
  connecting: "Upprättar säker anslutning till LinkedIn...",
  gettingProfile: "Hämtar profilinformation...",
  saving: "Sparar din information säkert...",
  connected: "LinkedIn-konto ansluten!",
  loadingSteps: {
    processing: "Behandlar auktorisering",
    connecting: "Upprättar säker anslutning",
    profile: "Hämtar profilinformation",
    finishing: "Slutför integration"
  },
  waitMessage: "Vänta medan vi slutför integrationen med ditt LinkedIn-konto...",
  error: {
    title: "Ett fel uppstod",
    solutions: {
      title: "Möjliga lösningar:",
      clearCookies: "Rensa webbläsarens cookies och cache",
      tryBrowser: "Prova en annan webbläsare (Chrome eller Firefox rekommenderas)",
      checkCookies: "Se till att du inte har blockerat cookies från LinkedIn",
      useHttps: "Försök att nå app.nuvik.io direkt via HTTPS"
    },
    backButton: "Tillbaka till inställningar"
  },
  success: {
    title: "LinkedIn-konto ansluten!",
    message: "Ditt LinkedIn-konto är nu anslutet till Nuvik.io.",
    redirect: "Du kommer att omdirigeras automatiskt..."
  }
};

export default callbackSwedish; 